import { render, staticRenderFns } from "./link-row.vue?vue&type=template&id=448ded3f&scoped=true&"
import script from "./link-row.vue?vue&type=script&lang=js&"
export * from "./link-row.vue?vue&type=script&lang=js&"
import style0 from "./link-row.vue?vue&type=style&index=0&id=448ded3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448ded3f",
  null
  
)

export default component.exports